// extracted by mini-css-extract-plugin
module.exports = {"container":"Section1-module--container--3pF9-","centered":"Section1-module--centered--13w05"};